import {Active} from '@dnd-kit/core';
// @todo: Migrate to @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components';
import React from 'react';
import {twMerge} from 'tailwind-merge';

import {getIsReorderingSections} from '../utils';

/**
 * This is a presentational component that is used to display the drag overlay for a section.
 * This should be decoupled from the section header.
 * https://docs.dndkit.com/api-documentation/draggable/drag-overlay#patterns
 */
export const WorkspaceSectionDragOverlay = ({
  activeItem,
}: {
  activeItem: Active | null;
}) => {
  if (!activeItem || !getIsReorderingSections(activeItem)) {
    return null;
  }

  return (
    <div
      className={twMerge(
        'cursor-grabbing',
        'px-12 py-4',
        'bg-white dark:bg-moon-100',
        'border border-moon-300 dark:border-moon-300'
      )}>
      <div className="flex h-[40px] items-center">
        <Button
          aria-label="Drag section overlay"
          className="cursor-grab active:cursor-grabbing"
          icon="drag-grip"
          size="small"
          variant="ghost"
        />
        <div className="ml-8 truncate text-moon-800">
          {activeItem?.data.current?.sectionName || 'Section'}
        </div>
      </div>
    </div>
  );
};
